import React, { useEffect, useRef, useState } from "react";
import { Star, Shield, Wrench, FileText, Hammer, MapPin } from "lucide-react";
import { whyChooseUs } from "../data/mockData";

const iconMap = { Star, Shield, Wrench, FileText, Hammer, MapPin };

const WhyChooseUs = () => {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) setIsVisible(true);
      },
      { threshold: 0.1 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section ref={sectionRef} className="py-28 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <p className="text-brand-mint-dark text-xs font-bold uppercase tracking-[0.25em] mb-4">
            Why Choose Us
          </p>
          <h2 className="font-heading text-3xl lg:text-4xl text-gray-900 mb-4">
            Quality You Can Rely On
          </h2>
          <p className="text-gray-500 text-[15px] max-w-xl mx-auto leading-relaxed">
            Trusted by homeowners and businesses across Hull and Yorkshire
            for clean, efficient air conditioning installs
          </p>
        </div>

        {/* Cards Grid */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {whyChooseUs.map((item, index) => {
            const IconComponent = iconMap[item.icon];
            return (
              <div
                key={item.id}
                className={`group p-7 rounded-xl bg-white border border-gray-100 hover:border-brand-mint/40 transition-all duration-250 hover:shadow-md hover:-translate-y-0.5 ${
                  isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"
                }`}
                style={{ transitionDelay: `${index * 40}ms` }}
              >
                <div className="w-11 h-11 rounded-lg bg-brand-mint/10 group-hover:bg-brand-mint/20 flex items-center justify-center mb-5 transition-colors duration-200">
                  {IconComponent && (
                    <IconComponent className="w-5 h-5 text-brand-mint-dark" />
                  )}
                </div>
                <h3 className="text-base font-bold text-gray-900 mb-1.5">
                  {item.title}
                </h3>
                <p className="text-gray-400 text-sm leading-relaxed">
                  {item.description}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
